import { render, staticRenderFns } from "./PollComments.vue?vue&type=template&id=1e91821a&"
import script from "./PollComments.vue?vue&type=script&lang=js&"
export * from "./PollComments.vue?vue&type=script&lang=js&"
import style0 from "./PollComments.vue?vue&type=style&index=0&id=1e91821a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports